import IconLock from "./icon-lock";
import {
  formatAdjustableTileValue,
  sliderFillPct,
} from "./tile-slider";

export default function ModeTile({
  mode,
  isProFeaturesLocked,
  holdingTileKey,
  draggingTileKey,
  releasingTileKey,
  fillGrowingKeys,
  onUpgradeClick,
  onAdjustablePointerDown,
  onAdjustablePointerMove,
  onAdjustablePointerUp,
  onAdjustablePointerCancel,
  onAdjustableClick,
}) {
  const isActive = !!mode.active;
  const isAdjustable = !!mode.slider && !isProFeaturesLocked;
  const isHolding = holdingTileKey === mode.key;
  const isEngaged = isActive || isHolding;
  const targetFillPct =
    isAdjustable && isEngaged ? sliderFillPct(mode.slider) : 0;
  const isFillGrowing = !!fillGrowingKeys[mode.key];
  const displayFillPct = isFillGrowing ? 0 : targetFillPct;
  const isDragging = draggingTileKey === mode.key;
  const isReleasing = releasingTileKey === mode.key;
  const showValue = isAdjustable && (isDragging || isReleasing);
  const reserveLabelText = isDragging;
  const showLockIcon = isProFeaturesLocked;
  const tileClassName = [
    "mode-tile",
    isEngaged && "mode-tile--active",
    isAdjustable && "mode-tile--adjustable",
    !isAdjustable && !isProFeaturesLocked && "mode-tile--toggle",
    isProFeaturesLocked && "mode-tile--locked",
    isDragging && "mode-tile--dragging",
    isFillGrowing && "mode-tile--fill-growing",
    isReleasing && "mode-tile--release-bounce",
  ]
    .filter(Boolean)
    .join(" ");

  const labelContent = isAdjustable ? (
    <span className="mode-tile__label-content">
      <span
        className={[
          "mode-tile__label-text",
          reserveLabelText && "mode-tile__label-text--reserve",
          isReleasing && "mode-tile__label-text--enter",
        ]
          .filter(Boolean)
          .join(" ")}
        aria-hidden={reserveLabelText}
      >
        {mode.label}
      </span>
      {showValue && (
        <span
          className={`mode-tile__label-value ${isReleasing ? "mode-tile__label-value--out" : ""}`}
        >
          {formatAdjustableTileValue(mode.slider)}
        </span>
      )}
    </span>
  ) : (
    <span className="mode-tile__label-text">{mode.label}</span>
  );

  const label = <span className="mode-tile__label">{labelContent}</span>;

  if (isAdjustable) {
    return (
      <button
        type="button"
        className={tileClassName}
        style={
          isEngaged ? { "--mode-tile-fill": `${displayFillPct}%` } : undefined
        }
        onPointerDown={(event) => onAdjustablePointerDown(event, mode)}
        onPointerMove={onAdjustablePointerMove}
        onPointerUp={(event) => onAdjustablePointerUp(event, mode)}
        onPointerCancel={onAdjustablePointerCancel}
        onClick={() => onAdjustableClick(mode)}
      >
        {label}
        {showLockIcon && (
          <span className="mode-tile__lock-badge" aria-hidden="true">
            <IconLock />
          </span>
        )}
      </button>
    );
  }

  return (
    <button
      type="button"
      className={tileClassName}
      onClick={() => {
        if (isProFeaturesLocked) {
          onUpgradeClick();
          return;
        }
        mode.onToggle();
      }}
    >
      {label}
      {showLockIcon && (
        <span className="mode-tile__lock-badge" aria-hidden="true">
          <IconLock />
        </span>
      )}
    </button>
  );
}
